import { CloseOutlined } from '@ant-design/icons';
import React, { ReactNode, CSSProperties } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabItem } from 'design-system/dist/hooks/useRouterTabs';
import { Flex, TabTag, Dropdown, RouterTabs, useRouterTabs } from 'design-system';

import { getDeviceId } from 'src/utils';
import IndexPage from 'src/pages/dashboard/app';

import styles from './main.module.css';
import { paths } from '../../routes/paths';
import { Product } from '../../services/user';
import { routerMap } from '../../routes/sections/dashboard';
import { STORAGE_KEY, STORAGEREFRESHTOKENKEY } from '../../auth/context/jwt/auth-provider';

const Notifications = React.lazy(() => import('notification-service-web/Notifications'));
// ----------------------------------------------------------------------

interface MainProps {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
}

export default function Main({ children, style, className }: MainProps) {
  const location = useLocation();
  const { handleTabChange, tabs, setDeleteData, setTabs, activeKey } = useRouterTabs(
    routerMap,
    'amoeba',
    children
  );
  const navigate = useNavigate();
  return (
    <div style={style} className={className}>
      <RouterTabs
        tabBarGutter={8}
        tabBarExtraContent={{
          right: (
            <Flex
              gap={16}
              style={{
                paddingRight: '12px',
                color: '#525866',
                paddingLeft: '6px',
              }}
            >
              <Notifications
                deviceId={getDeviceId()}
                product={Product.AMOEBA}
                token={localStorage.getItem(STORAGE_KEY) || ''}
                refreshToken={localStorage.getItem(STORAGEREFRESHTOKENKEY) || ''}
              />
            </Flex>
          ),
        }}
        onChange={handleTabChange}
        activeKey={activeKey}
        items={tabs.map((item, index) => {
          const isActive = activeKey === item.key;

          return {
            ...item,
            children: <div style={{ padding: 'var(--layout-padding)' }}>{item?.children}</div>,
            label: (
              <Dropdown
                menu={{
                  items: [
                    {
                      label: (
                        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                        <div
                          onClick={() => {
                            setDeleteData(undefined);
                            setTabs((prevState) => prevState.filter((v) => v.key === item.key));
                          }}
                        >
                          <CloseOutlined style={{ fontSize: '11px' }} /> 关闭其他
                        </div>
                      ),
                      key: '0',
                    },
                    {
                      label: (
                        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setTabs([]);
                            setDeleteData(undefined);
                            navigate(paths.dashboard.root);
                          }}
                        >
                          <CloseOutlined style={{ fontSize: '11px' }} /> 关闭所有
                        </div>
                      ),
                      key: '1',
                    },
                  ],
                }}
                trigger={['contextMenu']}
              >
                <TabTag active={isActive} className={styles.tabItem}>
                  {item.label}
                  <CloseOutlined
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      const activeIndex = tabs.findIndex((item) => item.key === activeKey);
                      const keyNumber =
                        // eslint-disable-next-line no-nested-ternary
                        activeIndex === index
                          ? index - 1 > -1
                            ? index - 1
                            : index + 1
                          : activeIndex;

                      if (tabs.length === 1) {
                        if (location.pathname === paths.dashboard.root) return;
                        navigate(paths.dashboard.root);
                        setDeleteData({ nextKey: paths.dashboard.root, deleteKey: item.key });
                        return;
                      }
                      const nextTag: TabItem = tabs[keyNumber] || {
                        label: '首页',
                        key: paths.dashboard.root,
                        children: <IndexPage />,
                      };
                      navigate(nextTag.key + (nextTag?.searchStr || ''));
                      setDeleteData({ nextKey: nextTag.key, deleteKey: item.key });
                    }}
                    className={styles.delete}
                    style={{
                      display: isActive ? 'block' : '',
                      fontSize: '11px',
                      position: 'relative',
                      zIndex: 1,
                      marginLeft: '4px',
                    }}
                  />
                </TabTag>
              </Dropdown>
            ),
          };
        })}
      />
    </div>
  );
}
